<div class="loader" [ngClass]="{'loader--has-opacity': transparent, 'loader--blank': blank}">
  <div class="loader_spinner">
    <div class="loader_double-bounce1"></div>
    <div class="loader_double-bounce2"></div>
  </div>
</div>
